"use client";

import Convert3dCubeBoldIcon from "@/app/_components/Icons/Convert3dCubeBoldIcon";
import { useGqlClient } from "@/Providers/GQLProvider";
import { Grid, Icon, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import ProductsList from "@/app/(main)/_components/SITESEARCH/ProductsList";
import Box from "@mui/material/Box";

export default function RelatedProductsSection({ code }: { code: number }) {
  const gqlClient = useGqlClient();
  const { data } = useQuery({
    queryKey: [gqlClient.searchRelatedProductsByCode.name, code],
    queryFn: async () => {
      return await gqlClient.searchRelatedProductsByCode({ code: code });
    },
  });
  if (!data || data.searchRelatedProductsByCode.length <= 0) {
    return null;
  }
  return (
    <Grid item xs={12} component="aside" id="related">
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: 0.5, mt: { xs: 1, md: 2 }, mb: { xs: 1.5, md: 2 } }}>
        <Icon fontSize="large" sx={{ width: "auto", color: "secondary.main" }}>
          <Convert3dCubeBoldIcon />
        </Icon>
        <Typography variant="h5" component="h2" sx={{ fontSize: { xs: "0.98rem", md: "1.4rem" } }} fontWeight={400} noWrap>
          محصولات <b>مشابه</b>
        </Typography>
      </Box>
      <ProductsList items={data.searchRelatedProductsByCode} surface="pdp_related" />
    </Grid>
  );
}
